//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { getIsBazaarvoiceNetworkSyndicationFrontendEnabled } from '@uia/rights/selectors/getUIARights';

// If BV syndication is enabled but galleries is not enabled,
// this is either an Instashop client or a BV syndication only client.
// In both cases, we should not allow the creation of custom streams.
export const getShouldNotAllowUgcStreams = createSelector(
  (state: ICuralateStore) =>
    getIsBazaarvoiceNetworkSyndicationFrontendEnabled(state),
  (state: ICuralateStore) => !!state.session.features.galleries,
  (state: ICuralateStore) =>
    !!state.session.features.bazaarvoice_network_syndication_ugc,
  (
    isBazaarvoiceSyndicationEnabled,
    isGalleriesEnabled,
    isBazaarvoiceUgcSyndicationEnabled,
  ) => {
    return (
      isBazaarvoiceSyndicationEnabled &&
      !isGalleriesEnabled &&
      !isBazaarvoiceUgcSyndicationEnabled
    );
  },
);
